import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import './SectionHeader.scss';
import classnames from 'classnames';

const SectionHeader = props => {
  const { additionalData, className, module, moduleList } = props;

  const regex = /^MODULE_SECTION/;
  const moduleIndex = moduleList?.modules?.findIndex(m => m?.module === module);
  const nextModule = moduleList?.modules[moduleIndex + 1]?.module;

  const isMoreOffersHeader = additionalData?.sectionTitle === 'MORE OFFERS';

  const hideModuleCreditToolsClass = classnames({
    'd-hide': module === 'MODULE_SECTION_SESAME_PLUS_CREDIT_TOOLS',
  });

  if (!regex.test(nextModule)) {
    return (
      <FlexContainer
        className={`SectionHeader ${hideModuleCreditToolsClass} ${className}`}
      >
        <FlexContainer
          className={
            'bgLBlue height30px items-align-center sectionwidth justify-between'
          }
        >
          <Label
            type={'captionBold m-text-10'}
            className={'system_neutral_n500_text'}
            tabIndex="-1"
          >
            {additionalData?.sectionTitle?.toUpperCase()}
          </Label>
          {isMoreOffersHeader && (
            <Label
              type={'Subtitle-3'}
              className={'italic margR16'}
              tabIndex="-1"
            >
              Based on your credit
            </Label>
          )}
        </FlexContainer>
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

export default SectionHeader;
